class CountrySelector extends HTMLElement {
  constructor() {
    super();
  }

  selectors = {
    button: "[data-country-selector-trigger]"
  };

  modifiers = {
    active: "active"
  };

  connectedCallback() {
    document.addEventListener("click", this.onButtonClicked.bind(this));
    document.addEventListener("keydown", this.onEscapeKeyPressed.bind(this));
  }

  onButtonClicked(event) {
    const isButtonClicked = event.target.closest(this.selectors.button);

    if (!isButtonClicked) {
      this.closeDropdown();
      return;
    }

    event.preventDefault();
    this.toggleDropdown();
  }

  onEscapeKeyPressed(event) {
    if (event.keyCode === 27) {
      this.closeDropdown();
    }
  }

  toggleDropdown() {
    if (this.classList.contains(this.modifiers.active)) {
      this.closeDropdown();
      return;
    }

    this.classList.add(this.modifiers.active);
  }

  closeDropdown() {
    this.classList.remove(this.modifiers.active);
  }
}

if (!customElements.get("country-selector")) {
  customElements.define("country-selector", CountrySelector);
}
